<script lang="ts" setup>
import type { Ref } from 'vue'
import { inject, ref } from 'vue'
import { cn } from '@/ui/helpers/utils'

const totalSlides: Ref<number> = inject('totalSlides') || ref(0)
const currentSlide: Ref<number> = inject('currentSlide') || ref(0)
</script>

<template>
    <div class="min-h-4 pt-1 lg:hidden">
        <div
            v-if="totalSlides > 1"
            class="gap-xs flex flex-wrap justify-center lg:hidden"
        >
            <span
                v-for="index in totalSlides"
                :key="index"
                :aria-current="currentSlide === index - 1 ? 'true' : 'false'"
                :class="
                    cn(
                        'i-gpp-pagination-circle bg-neutral-tertiary size-3xs shrink-0',
                        currentSlide === index - 1 && 'bg-neutral-primary-invert',
                    )
                "
            />
        </div>
    </div>
</template>
